import React from 'react';
import Sidebar from '../components/Sidebar';
import './all.sass';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({


  rootLight: {
    background: '#ffffff',
    flexGrow: 1

  },
  rootDark: {
    background: '#1f1f1f',
    flexGrow: 1
  },
  loginOptions: {
    marginLeft: 'auto',
    position: 'absolute',
    float: 'right',
    right: '0%'
  },
  mainLayout: {
    // padding: '64px',
    width: '100%',
  }
}));

/**
 * Site composition
 * @param {*} param0 
 */
const TemplateWrapper = ({ children }) => {
  const  classes = useStyles();
  let isDarkMode = false;
  if(typeof window !== 'undefined' &&window.localStorage.getItem("darkMode") === "on"){
     isDarkMode  = true;
  }

  return (
    <div className={(isDarkMode ? classes.rootDark : classes.rootLight)}>
      <Sidebar />
    </div>
  )
}

export default TemplateWrapper;
